import { Backdrop, CircularProgress } from '@mui/material';
import React from 'react';

const backdrop = {
  zIndex: 2000,
  color: '#fff',
};

export const SimpleBackdrop = ({ open = false }) => {
  return (
    <>
      <Backdrop sx={backdrop} open={open}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};
